import * as form from '../form';

export const legalTechnologyManipulating = (data = {}) => {
  const items = ((data.List || {}).items || []).map((x) => {
    const xitem = x.Item || {};
    return {
      Item: {
        Date: form.datecontrol(xitem.Date),
        Incident: form.textarea(xitem.Incident),
        Location: form.location(xitem.Location),
        Action: form.textarea(xitem.Action),
        // PVQ Form elements
        ManipulatingLocations: form.checkboxgroup(xitem.ManipulatingLocations),
        SystemName: form.text(xitem.SystemName),
        SystemOwner: form.text(xitem.SystemOwner),
        SystemOwnerNotApplicable: form.notapplicable(xitem.SystemOwnerNotApplicable),
        InformationType: form.radio(xitem.InformationType),
        InformationTypeOtherExplanation: form.textarea(xitem.InformationTypeOtherExplanation),
        HadSuccess: form.branch(xitem.HadSuccess),
        Frequency: form.radio(xitem.Frequency),
        FrequencyOtherExplanation: form.textarea(xitem.FrequencyOtherExplanation),
        Occurances: form.radio(xitem.Occurances),
        OccurancesExplanation: form.textarea(xitem.OccurancesExplanation),
        ActionDetails: form.textarea(xitem.ActionDetails),
        ActionOtherDetails: form.textarea(xitem.ActionOtherDetails),
        UnauthorizedActions: form.checkboxgroup(xitem.UnauthorizedActions),
        Reason: form.textarea(xitem.Reason),
        // End PVQ Only elements
      },
    };
  });
  return {
    HasManipulating: form.branch(data.HasManipulating),
    List: form.collection(items, (data.List || {}).branch),
  };
};
